import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import { parseIncomeData } from '../helpers';
import type {
  GetCompaniesRequestType,
  GetCompaniesResponseType,
} from '../types';

export const getCompanies = async ({
  pathParams: { boardId },
  queryParams: { email, search, perPage, sortBy },
}: GetCompaniesRequestType) => {
  const query = stringifyUrlQuery({
    email,
    search,
    perPage,
    sortBy,
  });

  const url = `/boards/${boardId}/company/${query}`;
  const response = await apiAuthClient.get<GetCompaniesResponseType>(url);
  const data = response.data.data || {};

  return {
    ...response.data,
    data: data.map(parseIncomeData),
  };
};
